var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderWarn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#FDFDD8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2437_87890)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 9C13.0328 9 9 13.0328 9 18C9 22.9672 13.0328 27 18 27C22.9672 27 27 22.9672 27 18C27 13.0328 22.9672 9 18 9ZM18 10.2C22.305 10.2 25.8 13.695 25.8 18C25.8 22.305 22.305 25.8 18 25.8C13.695 25.8 10.2 22.305 10.2 18C10.2 13.695 13.695 10.2 18 10.2ZM17.4 13.2V18C17.4 18.159 17.463 18.312 17.5755 18.4245L19.9755 20.8245C20.2095 21.0585 20.5897 21.0585 20.8238 20.8245C21.0578 20.5905 21.0578 20.2102 20.8238 19.9762L18.5992 17.7517V13.2C18.5992 12.8685 18.3308 12.6 17.9992 12.6C17.6677 12.6 17.3992 12.8685 17.3992 13.2L17.4 13.2Z",
    fill: "#B59800"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2437_87890"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderWarn);
export default __webpack_public_path__ + "static/media/order_warn.3a6743aaa5bd440cf6d369de38a89622.svg";
export { ForwardRef as ReactComponent };